import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { LangProvider, useContent, useLang } from "@/content";
import { Header, MenuSheet, TabBar } from "@/components/Nav";
import { Sidebar } from "@/components/Sidebar";
import { Footer } from "@/components/Footer";
import { Preloader } from "@/components/Preloader";
import { Lockup } from "@/components/Brand";
import { initLenis, destroyLenis, scrollToTop, scrollToId } from "@/lib/lenis";
import { Home, CategoriesPage, FinalistsPage, WinnersPage, ApplyPage, ContactPage, NotFound } from "@/pages";

const ScrollManager = () => {
  const loc = useLocation();
  useEffect(() => {
    initLenis();
    return destroyLenis;
  }, []);
  useEffect(() => {
    if (loc.hash) {
      const t = setTimeout(() => scrollToId(loc.hash.slice(1)), 120);
      return () => clearTimeout(t);
    }
    scrollToTop();
  }, [loc.key, loc.hash]);
  return null;
};

const Page = ({ children }) => (
  <motion.main id="main" className="lg:ms-[340px]" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    {children}
  </motion.main>
);

const ComingSoon = () => {
  const c = useContent();
  const { setLang } = useLang();
  return (
    <main className="grain flex min-h-screen flex-col items-center justify-center bg-night px-6 text-center text-white" data-testid="coming-soon">
      <Lockup height={64} />
      <h1 className="mt-10 font-serif text-[2rem] italic md:text-[3rem]" data-testid="coming-soon-title">{c.title}</h1>
      <p className="mt-4 text-[0.7rem] uppercase tracking-[0.4em] text-copper">{c.site.name} {c.site.year}</p>
      <button type="button" onClick={() => setLang("fr")} data-testid="coming-soon-back" className="link-line mt-12 text-[0.72rem] uppercase tracking-[0.3em] text-white/80">{c.back}</button>
    </main>
  );
};

const Shell = () => {
  const c = useContent();
  const [menu, setMenu] = useState(false);
  const [intro, setIntro] = useState(true);
  if (c.comingSoon) return <ComingSoon />;
  return (
    <>
      {intro && <Preloader onDone={() => setIntro(false)} />}
      {/* Mobile : en-tête + menu plein écran. Desktop : remplacés par la colonne latérale. */}
      <div className="lg:hidden">
        <Header onOpenMenu={() => setMenu(true)} />
        <MenuSheet open={menu} onClose={() => setMenu(false)} />
      </div>
      <Sidebar />
      <Page>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/finalistes" element={<FinalistsPage />} />
          <Route path="/gagnants" element={<WinnersPage />} />
          <Route path="/candidater" element={<ApplyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Page>
      <div className="lg:ms-[340px]">
        <Footer />
      </div>
      <TabBar />
    </>
  );
};

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollManager />
        <Shell />
      </BrowserRouter>
    </LangProvider>
  );
}
